/**
 * Raw color tokens. Change the brand here; the MUI theme is derived from these.
 * Lime (#C6EF34) + violet (#5B2DB0) on a violet-tinted neutral scale.
 */
export const lime = {
  50: '#F8FEE6',
  100: '#EEFBC4',
  200: '#E2F88F',
  300: '#D4F45E',
  400: '#C6EF34',
  500: '#B2DB1C',
  600: '#8FB312',
  700: '#5F7A00',
  800: '#435700',
  900: '#2B3900',
} as const;

export const violet = {
  50: '#F6F2FE',
  100: '#EDE7FA',
  200: '#DBCFF6',
  300: '#BBA4EE',
  400: '#9674E0',
  500: '#7649CF',
  600: '#5B2DB0',
  700: '#4A2394',
  800: '#3A1B74',
  900: '#2A1263',
} as const;

/** Violet-tinted neutrals: light surfaces → dark surfaces. */
export const ink = {
  0: '#FFFFFF',
  25: '#FBFAFE',
  50: '#F5F3FA',
  100: '#ECE8F4',
  200: '#DDD7EB',
  300: '#C3BBD6',
  400: '#9D95B3',
  500: '#6E6687',
  600: '#524A6B',
  700: '#3B3158',
  800: '#2A2146',
  850: '#221A3C',
  900: '#1C1433',
  950: '#140E26',
  1000: '#0D0919',
} as const;

export const red = {
  light: '#C9303E',
  dark: '#FF8A8F',
} as const;

export const amber = {
  light: '#A15C00',
  dark: '#FFC46B',
} as const;
